var map = {
	"./cs.json": "7e905",
	"./da.json": "6398",
	"./de.json": "2508",
	"./en.json": "e088",
	"./es.json": "d90a",
	"./fr-fr.json": "1c03",
	"./it.json": "06b7",
	"./ja.json": "19d0",
	"./ko.json": "4f29",
	"./nl.json": "674d",
	"./no.json": "5a24",
	"./pl.json": "b890",
	"./pt-br.json": "8d5b",
	"./ru.json": "626a7",
	"./sv.json": "3f3d",
	"./zh-cn.json": "cc8d",
	"./zh-tw.json": "1331"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "5a82";